import axios from "axios";
import { store } from "@/store";

const request = axios.create({
    baseURL: "/",
});

request.interceptors.request.use((conf) => {
    const loginResult = store.getState().user.loginResult;
    return Promise.resolve(Object.assign(conf, {
        headers: { "Authorization": loginResult?.token }
    }));
}, (err) => {
    return Promise.reject(err);
});

request.interceptors.response.use((res) => {
    if (res.data.code >= 400) {
        return Promise.reject(res.data.msg);
    }
    return Promise.resolve(res);
}, (err) => {
    if (err.status === 401) {
        const is_development = process.env.NODE_ENV === "development";
        const systemConfig = store.getState().global.systemConfig;
        
        if (!is_development) {
            if (systemConfig?.is_polaris && systemConfig.logout_url) {
                window.location.replace(systemConfig.logout_url);
                return;
            }
        }
        
        window.location.replace(`/login`);
    }
    return Promise.reject(err);
});

export default request;